// extracted by mini-css-extract-plugin
module.exports = {"ContactContainer":"style_ContactContainer__NW50q","ContactBox":"style_ContactBox__3FFwq","ContactImages":"style_ContactImages__ApQxa","Divider":"style_Divider__mDsV0"};